/*eslint-disable*/
import {SelectListItem} from "./Styled";
import React from "react";

SelectListHandler = React.memo(SelectListHandler, (prevProps, nextProps) => {
    // true means do NOT rerender
    // false means DO rerender
    // console.log("select list handlder", prevProps, nextProps);

    // these ones are easy if any of these changed, we should re-render
    if (prevProps.getItemProps !== nextProps.getItemProps) return false;
    if (prevProps.item !== nextProps.item) return false;
    if (prevProps.index !== nextProps.index) return false;
    if (prevProps.isDisabled !== nextProps.isDisabled) return false;
    if (prevProps.isSelected !== nextProps.isSelected) return false;
    if (prevProps?.withOptGroup !== nextProps?.withOptGroup) return false;
    // this is trickier. We should only re-render if this list item:
    // 1. was highlighted before and now it's not
    // 2. was not highlighted before and now it is
    if (prevProps.highlightedIndex !== nextProps.highlightedIndex) {
        const wasPrevHighlighted = prevProps.highlightedIndex === prevProps.index;
        const isNowHighlighted = nextProps.highlightedIndex === nextProps.index;
        return wasPrevHighlighted === isNowHighlighted;
    }
    return true;
});

export function SelectListHandler({
    getItemProps,
    item,
    highlightedIndex,
    index,
    //selectedItems,
    isDisabled,
    isSelected,
    withOptGroup,
    ...rest
}) {
    return (
        <SelectListItem
            isHighligted={highlightedIndex === index}
            withOptGroup={withOptGroup}
            {...getItemProps({
                item,
                index,
                disabled: isDisabled,
                ...rest,
            })}
        />
    );
}
